import { render, staticRenderFns } from "./AIAssistantButton.vue?vue&type=template&id=7b420a78&scoped=true&"
import script from "./AIAssistantButton.vue?vue&type=script&lang=js&"
export * from "./AIAssistantButton.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistantButton.vue?vue&type=style&index=0&id=7b420a78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b420a78",
  null
  
)

export default component.exports